import { createLifecycleFor } from 'ext/lib/collections';

export const TYPE = 'userProperties' as const;

export const { resolve, reject, patterns } = createLifecycleFor(TYPE);
